"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 94: UN1ROM
 * ------------------------------------------------------------------ */
// UN1ROM

function register(Mappers) {
  Mappers[94] = function (nes) {
    this.nes = nes;
  };

  Mappers[94].prototype = new Mappers[0]();

  Mappers[94].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    this.loadRomBank(value & 0x0f, 0x8000);
  };

  Mappers[94].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("UN1ROM: Invalid ROM! Unable to load.");
    }

    this.reset();
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(this.nes.rom.romCount - 1, 0xc000);
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };
}

module.exports = { register: register };
